import * as Sentry from '@sentry/browser'

// Utils
import { TRACKING_ENABLED, PIXELS_ENABLED, CURRENCY } from '@constants'
import BingPixel from 'lib/bingpixel'
import TiktokPixel from 'lib/tiktokpixel'
import TwitterPixel from 'lib/twitterpixel'

export default (name: string, data?: Record<string, unknown>) => {
  if (TRACKING_ENABLED) {
    // Legacy ga
    if (ga) {
      if (data && data.eventCategory && data.eventAction && data.eventLabel) {
        if (data.eventValue) {
          if (name === 'Social') {
            const { campaign, ...dataWithoutCampaign } = data // eslint-disable-line
            ga('send', { hitType: 'social', ...dataWithoutCampaign })
            ga('send', 'event', 'Share', data.socialNetwork, data.campaign)
          } else {
            ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, data.eventValue)
          }
        }
        ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel)
      } else {
        ga('send', 'event', 'action', name)
      }
    }

    // gtag (new ga)
    if (gtag) {
      if (name === 'Social' && data?.socialNetwork) {
        gtag('event', 'share', {
          content_type: data.socialNetwork,
          item_id: data?.campaign,
        })
      }
      if (data && data.eventCategory && data.eventAction && data.eventLabel) {
        if (data.eventValue) {
          gtag('event', data.eventAction as string, {
            event_category: data.eventCategory,
            event_label: data.eventLabel,
            value: data.eventValue,
          })
        }
        gtag('event', data.eventAction as string, {
          event_category: data.eventCategory,
          event_label: data.eventLabel,
        })
      } else {
        gtag('event', name)
      }
    }

    if (PIXELS_ENABLED) {
      if (name === 'changedPlan') {
        TiktokPixel.changedPlan(data?.eventLabel as string, data?.eventValue as number, CURRENCY)
        TwitterPixel.event('Purchase', {
          value: data?.eventValue,
          currency: CURRENCY,
          num_items: 1,
        })
        BingPixel.event(data?.eventAction as string, {
          event_category: data?.eventCategory,
          event_label: data?.eventLabel,
          event_value: data?.eventValue,
        })
      }
      if (name === 'CompleteRegistration') {
        TwitterPixel.event('Sign up')
        BingPixel.event(name)
      }
    }

    Sentry.addBreadcrumb({
      category: 'tracking',
      message: name,
      level: Sentry.Severity.Info,
    })
    import(
      /* webpackChunkName: 'tracking' */
      'react-facebook-pixel'
    ).then(({ default: ReactPixel }) => {
      if (
        name === 'Invite' ||
        name === 'Played track' ||
        name === 'Play hero video' ||
        name === 'changedPlan' ||
        name === 'mediaAndTextBlock click' ||
        name === 'Visit /subscribe' ||
        name === 'Click hero button' ||
        name === 'Loop'
      ) {
        return ReactPixel.trackCustom(name, data)
      }

      return ReactPixel.track(name, data)
    })
  }
  return null
}
